"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBexApiContext = void 0;
var bex_api_context_1 = require("./bex-api-context");
var getBexApiContext = function (context) { return ({
    siteId: context.site.id,
    locale: context.locale,
    eapid: context.site.eapid,
    currency: context.currency,
    device: {
        type: getDeviceType(context)
    },
    identity: {
        duaid: context.deviceId,
        expUserId: getExpUserId(context),
        tuid: getTuid(context),
        authState: getAuthState(context)
    },
    privacyTrackingState: getPrivacyState(context),
    debugContext: getDebugContext(context)
}); };
exports.getBexApiContext = getBexApiContext;
var getExpUserId = function (context) {
    return context.user && context.user.expUserId ? context.user.expUserId.toString() : null;
};
var getTuid = function (context) {
    return context.user && context.user.tuid ? context.user.tuid.toString() : null;
};
var getDeviceType = function (context) {
    var deviceInformation = context.deviceInformation;
    if (!deviceInformation) {
        return bex_api_context_1.DeviceType.DESKTOP;
    }
    if (deviceInformation.type) {
        return deviceInformation.type;
    }
    if (deviceInformation.mobile && deviceInformation.tablet) {
        return bex_api_context_1.DeviceType.MOBILE_TABLET;
    }
    else if (deviceInformation.mobile && !deviceInformation.tablet) {
        return bex_api_context_1.DeviceType.MOBILE_PHONE;
    }
    else {
        return bex_api_context_1.DeviceType.DESKTOP;
    }
};
var getAuthState = function (context) {
    if (context && context.user && context.user.authState) {
        return context.user.authState;
    }
    return bex_api_context_1.AuthenticationState.ANONYMOUS;
};
var getPrivacyState = function (context) {
    if (context.privacyTrackingState) {
        return context.privacyTrackingState;
    }
    if (context.site.optInPrivacyInfo && context.site.optInPrivacyInfo.set) {
        return context.site.optInPrivacyInfo.yesSelected
            ? bex_api_context_1.PrivacyTrackingState.CAN_TRACK
            : bex_api_context_1.PrivacyTrackingState.CAN_NOT_TRACK;
    }
    else {
        return undefined;
    }
};
var getDebugContext = function (context) {
    if (!context.debugContext) {
        return;
    }
    var _a = context.debugContext, alterMode = _a.alterMode, abacusOverrides = _a.abacusOverrides;
    return {
        abacusOverrides: abacusOverrides || [],
        alterMode: alterMode && bex_api_context_1.AlterMode[alterMode]
    };
};
//# sourceMappingURL=bex-api-context-adapter.js.map